import React from 'react';
import { Link } from 'react-router-dom';
import LegalPolicyLayout from '@/components/legal/LegalPolicyLayout';
import { LEGAL_ROUTES } from '@/constants/legalEntity';

export const CookiePolicy: React.FC = () => {
  return (
    <LegalPolicyLayout title="Cookie Policy">
      <section className="mb-8">
        <h2>1. What are cookies</h2>
        <p>
          Cookies are small text files stored on your device. We also use similar technologies (local storage
          for auth tokens) where needed for the app to function.
        </p>
      </section>

      <section className="mb-8">
        <h2>2. How we use cookies</h2>
        <h3>2.1 Essential</h3>
        <p>Required for security, session login, and core navigation. These cannot be disabled if you use the
          app.</p>
        <h3>2.2 Authentication</h3>
        <p>JWT or session tokens stored to keep you signed in to the dashboard and student areas.</p>
        <h3>2.3 Analytics (optional)</h3>
        <p>We may use analytics to understand traffic on the marketing site. Where consent is required, we
          will ask before enabling non-essential analytics cookies.</p>
      </section>

      <section className="mb-8">
        <h2>3. Third-party cookies</h2>
        <p>
          Lemon Squeezy checkout may set cookies during payment. Embedded video players (e.g. YouTube) on
          teacher portfolios may set their own cookies under their policies.
        </p>
      </section>

      <section className="mb-8">
        <h2>4. Managing cookies</h2>
        <p>
          You can block cookies in your browser settings; some features may stop working. For privacy rights,
          see our <Link to={LEGAL_ROUTES.privacy}>Privacy Policy</Link>.
        </p>
      </section>
    </LegalPolicyLayout>
  );
};
